/* AdvisoryDetailRenderer.js */

"use strict";

//const _ = require('lodash');
const PopUpWidget = require("@gluenetworks/steve_ui_widgets").PopUp;

class AdvisoryDetailRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("advisory-detail-column");
        this._rootElem.component = this._model;

        this._viewMoreIcon = document.createElement("actionable-icon-gl");
        this._viewMoreIcon.dataset.icon = "configdrift.view_more";
        this._viewMoreIcon.setAttribute("title", "View Details");
        this._rootElem.appendChild(this._viewMoreIcon);

        this._createPopup();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._viewMoreIcon.remove();
            this._viewMoreIcon = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._popUpWidget.on("PopUpVisible", (this._onContent = this._onContent.bind(this)));
        //this._model.on("ViewMore", this._onViewMore = this._onViewMore.bind(this));
        //this._viewMoreIcon.addEventListener('click', this._onViewMoreIconUserClick = this._onViewMoreIconUserClick.bind(this));
    }

    _unregisterListeners() {
        if (this._popUpWidget) {
            this._popUpWidget.removeListener("PopUpVisible", this._onContent);
        }
        //this._model.removeAllListeners("ViewMore");
        //this._viewMoreIcon.removeEventListener('click', this._onViewMoreIconUserClick);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            // this._setAdvisoryColumn(anchor);
            resolve();
        });
        return prom;
    }

    _createPopup() {
        let viewMoreContentElement = document.createElement("view-more-pop-up");
        viewMoreContentElement.classList.add("advisory-summary");
        viewMoreContentElement.innerHTML = this._model._getToolTipContent(true);
        this._popUpWidget = new PopUpWidget({
            content: this._renderAnchorSummary(viewMoreContentElement).outerHTML,
            anchor: this._rootElem,
            anchorPoint: "left",
            displayDirection: "bottomLeft",
            openOnHover: true,
            parent: viewMoreContentElement.parentNode
        });

        this._registerListeners();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }
    _renderAnchorSummary(viewMoreContentElement) {
        let anchors = viewMoreContentElement.getElementsByTagName("a");
        for (let i = 0; i < anchors.length; i++) {
            anchors[i].setAttribute("target", "_blank");
        }
        return viewMoreContentElement;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onViewMore(newVal) {
        this._setViewMore(newVal);
    }

    _onViewMoreIconUserClick() {
        // this._model._triggerUserCellAction({
        //     // action: 'viewMore',
        //     // viewDetails: this._model._getToolTipContent()
        // });
    }

    _onContent() {
        if (!this._model._logsRendered) {
            this._updateContent();
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setViewMore(/*newVal*/) {
        console.log("set view more");
    }

    _updateContent() {
        let viewMoreContentElement = document.createElement("view-more-pop-up");
        viewMoreContentElement.classList.add("activity-log-popup");
        viewMoreContentElement.innerHTML = this._model._getToolTipContent();
        this._popUpWidget.setContent(viewMoreContentElement.outerHTML);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = AdvisoryDetailRenderer;
